<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>
    {{ (data.estimateCategory ? 'estimate-categories.dialog.edit-title' : 'estimate-categories.dialog.create-title') | translate }}
  </h2>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div fxLayout="column">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'estimate-categories.dialog.name' | translate }}</mat-label>
        <input matInput type="text" formControlName="name" />
        <mat-error *ngIf="form.controls.name.hasError('duplicateName')">
          {{ 'estimate-categories.dialog.duplicate-name-error' | translate }}
        </mat-error>
        <mat-error *ngIf="form.controls.name.hasError('sameAsParent')">
          {{ 'estimate-categories.dialog.same-as-parent-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'common.status' | translate }}</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let status of statuses" [value]="status">
            {{ (status === 'active' ? 'common.active' : 'common.inactive') | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>{{ 'common.cancel' | translate }}</button>

    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
    >
      {{ 'common.save' | translate }}
    </button>
  </mat-dialog-actions>
</form>
